import React from 'react';
import type { AutoCompleteBasicProps, SuggestionFetcher } from '@/app/components/search/components/AutocompleteBasic';
import Autocomplete from '@/app/components/search/components/AutocompleteBasic';
import type { Filter, FilterDataSearchDynamic } from '@/app/common/filters/core/filtersTypes.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';

export type FilterSearchDynamicSelected = {
  target: {
    name: string;
    value: string;
  };
};

type Props = {
  filter: Filter;
  name: string;
  suggestionFetcher: SuggestionFetcher;
  onUpdate: (e: FilterSearchDynamicSelected) => void;
};

export const FilterSearchDynamicSelector = ({ filter, name, suggestionFetcher, onUpdate }: Props) => {
  const filterData = filter.data as FilterDataSearchDynamic;
  const { value, placeholder, noResultsLabel } = filterData;
  const { disabled } = filter;
  const { isMobile } = useFiltersUiData();

  const handleSelected = (chosenValue: string) => {
    onUpdate({ target: { name, value: chosenValue } });
  };

  const autocompleteProps = {
    suggestionFetcher,
    placeholder,
    initialValue: value,
    noSuggestionsLabel: noResultsLabel,
    isFullScreen: isMobile,
    focusOnLoad: isMobile,
    onSelected: handleSelected,
    disabled,
  } as AutoCompleteBasicProps;

  return <Autocomplete {...autocompleteProps} />;
};
